module.exports = __webpack_public_path__ + "img/card.6916068c.png";